import { createContext, useContext, useState } from "react";
import { Snackbar, SnackbarContainer, SnackbarProps } from "./Snackbar";
import { v1 } from "uuid";

export type Snackbar = Omit<SnackbarProps, "onClose" | "id" | "visible">;

export type SnackbarProviderProps = {
    children: React.ReactNode;
};

export type SnackbarProviderState = {
    openSnackbar: (snackbar: Snackbar) => void;
}

const initialState: SnackbarProviderState = {
    openSnackbar: () => { },
};

const SnackbarProviderContext = createContext<SnackbarProviderState>(initialState);

export const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
    const [snackbars, setSnackbars] = useState<Omit<SnackbarProps, "onClose">[]>([]);

    const openSnackbar = (snackbar: Snackbar) => {
        const newSnackbar = {
            ...snackbar,
            id: v1(),
            visible: true,
        }
        setSnackbars((prev) => [...prev, newSnackbar]);
    }

    const removeSnackbar = (id: string) => {
        setSnackbars((prev) =>
            prev.map((snackbar) =>
                snackbar.id === id && snackbar.visible
                    ? { ...snackbar, visible: false }
                    : snackbar
            )
        );
    };

    return (
        <SnackbarProviderContext.Provider value={{ openSnackbar }}>
            {children}

            <SnackbarContainer snackbars={snackbars} onClose={removeSnackbar} />
        </SnackbarProviderContext.Provider>
    );
}

SnackbarProvider.useSnackbar = () => {
    const context = useContext(SnackbarProviderContext);

    if (!context) {
        throw new Error("useSnackbar must be used within a SnackbarProvider");
    }

    return context;
};